export default __webpack_public_path__ + "static/media/finance-gif3.cbf480a0.gif";